import React, { useState, useEffect } from 'react';
import { authService, prizeService } from '../services';
import BackButton from '../components/BackButton';

function Profile() {
  const [user, setUser] = useState(null);
  const [redemptions, setRedemptions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    loadProfile();
    loadRedemptions();
  }, []);

  const loadProfile = async () => {
    try {
      const data = await authService.getProfile();
      setUser(data);
    } catch (err) {
      setError('Failed to load profile');
    } finally {
      setLoading(false);
    }
  };

  const loadRedemptions = async () => {
    try {
      const data = await prizeService.getUserRedemptions();
      setRedemptions(data);
    } catch (err) {
      console.error('Failed to load redemptions:', err);
    }
  };

  if (loading) {
    return <div className="loading">正在加载个人资料...</div>;
  }

  if (error || !user) {
    return <div className="container"><div className="form-error">{error || '未找到用户'}</div></div>;
  }

  return (
    <div className="container">
      <BackButton to="/" />
      <h1 className="page-title">我的个人资料</h1>
      
      <div className="card" style={{ maxWidth: '800px', margin: '0 auto 2rem' }}>
        <h2 className="card-title" style={{ borderBottom: '2px solid var(--bg-purple-light)', paddingBottom: '1rem', marginBottom: '1.5rem' }}>用户信息</h2>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '1.5rem' }}>
          <div style={{ padding: '1rem', backgroundColor: 'var(--bg-light)', borderRadius: '12px', border: '1px solid var(--bg-purple-light)' }}>
            <div style={{ fontSize: '0.875rem', color: 'var(--text-light)', marginBottom: '0.5rem', display: 'flex', alignItems: 'center' }}>
              <span style={{ marginRight: '0.5rem' }}>👤</span> 用户名
            </div>
            <div style={{ fontSize: '1.125rem', fontWeight: '600', color: 'var(--text-dark)' }}>{user.username}</div>
          </div>
          
          <div style={{ padding: '1rem', backgroundColor: 'var(--bg-light)', borderRadius: '12px', border: '1px solid var(--bg-purple-light)' }}>
            <div style={{ fontSize: '0.875rem', color: 'var(--text-light)', marginBottom: '0.5rem', display: 'flex', alignItems: 'center' }}>
              <span style={{ marginRight: '0.5rem' }}>📧</span> 邮箱
            </div>
            <div style={{ fontSize: '1.125rem', fontWeight: '600', color: 'var(--text-dark)' }}>{user.email}</div>
          </div>

          <div style={{ padding: '1rem', backgroundColor: 'var(--bg-light)', borderRadius: '12px', border: '1px solid var(--bg-purple-light)' }}>
            <div style={{ fontSize: '0.875rem', color: 'var(--text-light)', marginBottom: '0.5rem', display: 'flex', alignItems: 'center' }}>
              <span style={{ marginRight: '0.5rem' }}>⭐</span> 积分
            </div>
            <div style={{ fontSize: '1.125rem', fontWeight: '600', color: 'var(--primary-purple)' }}>{user.points}</div>
          </div>

          <div style={{ padding: '1rem', backgroundColor: 'var(--bg-light)', borderRadius: '12px', border: '1px solid var(--bg-purple-light)' }}>
            <div style={{ fontSize: '0.875rem', color: 'var(--text-light)', marginBottom: '0.5rem', display: 'flex', alignItems: 'center' }}>
              <span style={{ marginRight: '0.5rem' }}>🛡️</span> 角色
            </div>
            <div style={{ fontSize: '1.125rem', fontWeight: '600', color: 'var(--text-dark)', textTransform: 'capitalize' }}>
              {user.role === 'admin' ? '管理员' : user.role === 'premium' ? '主播' : '普通用户'}
            </div>
          </div>
        </div>
      </div>

      <div style={{ maxWidth: '800px', margin: '0 auto' }}>
        <h2 style={{ color: 'var(--primary-purple)', marginBottom: '1rem' }}>
          兑换历史
        </h2>
        
        {redemptions.length === 0 ? (
          <div className="empty-state">
            <div className="empty-state-icon">🎁</div>
            <p>暂无兑换记录</p>
          </div>
        ) : (
          <div className="grid" style={{ gridTemplateColumns: 'repeat(auto-fill, minmax(250px, 1fr))' }}>
            {redemptions.map((redemption) => (
              <div key={redemption.id} className="card">
                <img 
                  src={redemption.prize_image || 'https://via.placeholder.com/250x150/9b59b6/ffffff?text=Prize'} 
                  alt={redemption.prize_name}
                  className="card-image"
                  style={{ height: '150px' }}
                />
                <h3 style={{ fontSize: '1.25rem', marginBottom: '0.5rem' }}>{redemption.prize_name}</h3>
                <p style={{ color: 'var(--text-light)', fontSize: '0.875rem', marginBottom: '0.5rem' }}>
                  {redemption.prize_description}
                </p>
                <div style={{ 
                  padding: '0.5rem', 
                  backgroundColor: redemption.status === 'completed' ? '#27ae60' : 
                                   redemption.status === 'cancelled' ? '#e74c3c' : '#f39c12',
                  color: 'white',
                  borderRadius: '4px',
                  fontSize: '0.875rem',
                  textAlign: 'center',
                  marginBottom: '0.5rem'
                }}>
                  {redemption.status === 'completed' ? '已完成' : 
                   redemption.status === 'cancelled' ? '已取消' : '处理中'}
                </div>
                <p style={{ color: 'var(--text-light)', fontSize: '0.875rem' }}>
                  {new Date(redemption.created_at).toLocaleDateString()}
                </p>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default Profile;
